
<v-container class="step-container" v-if="unit && current">
    <c-drop-message
        v-if     = "drag.notAllowed"
        :message ="drag.message"
    />

    <drop class="cut" @drop="onDrop" mode="cut" :accepts-type="onAcceptType">
        <v-row class="no-frame">
            <v-col class="step-first-column">
                <div class="v-flex w-100">
                    <inc-site-down-switch
                        v-if      = "data.tags.includes('sitedown')"
                        v-model   = "current.unitDown"
                        class     = "mt-0"
                        :readonly = "siteDownEnabled"
                    />
                </div>
                <div>
                    <v-switch
                        v-model       = "current.unitDownAlert"
                        class         = "step-site-down mt-0 pt-1 pb-1"
                        :class        = "current.unitDownAlert===true?'step-site-down-active':''"
                        :hide-details = "true"
                        :readonly     = "readonly"
                        :color        = "current.unitDownAlert?'error':'primary'"
                        :ripple       = "false"
                        @change       = "onUnitDownAlert"
                    >
                        <template v-slot:label>
                            <span :class="current.unitDownAlert===true?'step-site-down-active':''">Stillstand im IOT Dashboard</span>
                        </template>
                    </v-switch>
                </div>

                <inc-status
                    v-model = "current.status"
                    :items  = "step.status"
                    @change = "onStatusChanged"
                    class   = "mt-6"
                />

                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <msd-users
                            v-model     = "incident.responsible"
                            :background = "fileEntryFieldBackground"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <f-date-picker
                            label   = "inc.edit.common.executionDate"
                            v-model = "current.executionDate"
                            :rules  = "[requiredOnProceccingScheduledRule]"
                            class   = "w-100"
                        />
                    </v-col>
                </v-row>

                <v-text-field
                    v-model           = "data.reporter"
                    :label            = "$t('inc.edit.general.reporter')"
                    :background-color ="fileEntryFieldBackground"
                    autocomplete      = "off"
                    autocorrect       = "off"
                    autocapitalize    = "off"
                    spellcheck        = "false"
                />

                <inc-processing-interval
                    :data          = "data"
                    :status        = "current.status"
                    :background    = "fileEntryFieldBackground"
                    @start-changed = "validate"
                    @end-changed   = "validate"
                />

                <v-text-field
                    v-model           = "incident.externalId"
                    :label            = "$t('inc.edit.general.external')"
                    :background-color = "fileEntryFieldBackground"
                    autocomplete      = "off"
                    autocorrect       = "off"
                    autocapitalize    = "off"
                    spellcheck        = "false"
                />

                <f-date-picker
                    label             = "inc.edit.general.offerDate"
                    v-model           = "incident.offerDate"
                    :background-color = "fileEntryFieldBackground"
                    class             = "w-100"
                />

                <inc-unit-down-interval
                    v-if          = "data.tags.includes('sitedown')"
                    :unitdata     = "current"
                    :status       = "current.status"
                    @endchanged   = "onUnitDownEndChanged"
                    @startchanged = "onUnitDownStartChanged"
                />

                <c-v-spacer />
            </v-col>
            <v-col class="step-middle-column">
                <v-switch
                    v-if           = "data.tags.includes('invoice')"
                    v-model        = "data.invoice"
                    :label         = "$t('inc.edit.common.invoice')"
                    class          = "mt-0 pt-1 pb-1"
                    :class         = "fileEntryFieldBackground"
                    @change        = "onInvoice"
                    hide-details

                />

                <v-textarea
                    v-model        = "current.description"
                    :rules         = "[requiredRule]"
                    :label         = "$t('inc.edit.general.description')"
                    :rows          = "rows"
                    class          = "mt-4"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    no-resize
                    counter
                />

                <v-textarea
                    v-model        = "current.cause"
                    :label         = "$t('inc.edit.general.cause')"
                    :rows          = "rows"
                    class          = "mt-3"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    no-resize
                    counter
                />
                <v-textarea
                    v-model        = "current.measure"
                    :rules         = "[requiredOnTerminationRule]"
                    :label         = "$t('inc.edit.general.measure')"
                    :rows          = "rows"
                    class          = "mt-3"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    no-resize
                    counter
                />
                <c-v-spacer />
            </v-col>
            <v-col class="step-middle-column">
                <v-row
                    class="no-frame"
                    style="margin-top: 42px!important;"
                    v-if="data.tags.includes('components')"
                >
                    <v-col class="no-frame">
                        <inc-components
                            v-model     = "current.components"
                            :site       = "unit"
                            :status     = "current.status"
                            :incident   = "incident"
                            :height     = "250"
                            style       = "border-radius: 5px 0 5px 5px; margin-top: -1px"
                            :warranties = "warrenties (unit.id)"
                            @input      = "onComponents"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame mt-11  lm-border pa-2" style="min-height: 200px">
                    <v-col class="no-frame">
                        <v-row class="no-frame ">
                            <inc-manufacturer
                                v-model     = "data.manufacturer"
                                :rules      = "[requiredOnTerminationRule]"
                                :background = "fileEntryFieldBackground"
                                @changed    = "onManufacturer"
                            />
                        </v-row>
                        <v-row class="no-frame">
                            <c-contact-select
                                v-if        = "data.manufacturer"
                                v-model     = "data.contactIds"
                                label       = "Kontakte"
                                class       = "w-100"
                                :company-id = "data.manufacturer ? data.manufacturer.id : null"
                                :incident   = "incident"
                                :index      = "index"
                                :status     = "current.status"
                                :background = "fileEntryFieldBackground"
                                @sendmail   = "onSendmail"
                            />
                        </v-row>
                    </v-col>
                </v-row>
                <c-v-spacer />
            </v-col>
            <v-col class="step-last-column" style="padding-right: 5px">
                <crm-journal
                    :incident = "incident"
                    @front    ="onJournalFront"
                    @saved    = "success=true"
                    style     = "margin-top: -10px"
                />
            </v-col>
        </v-row>
    </drop>
</v-container>
